/* eslint-disable */
import Vue            from 'vue';
import Router         from 'vue-router';
import Login          from '@/views/Login.vue';
import Order          from '@/views/Order.vue';
import NewOrder       from '@/views/NewOrder.vue';
import AddCustomer    from '@/views/AddCustomer.vue';
import AddStaff       from '@/views/AddStaff.vue';
import Staffs         from '@/views/Staffs.vue';
import ChangeOrder    from '@/views/ChangeOrder.vue';
import BillsDetail    from '@/views/BillsDetail.vue';
import BillsOpen      from '@/views/BillsOpen.vue';
import BillsReprint   from '@/views/BillsReprint.vue';
import OrderLevel     from '@/views/OrderLevel.vue';
import VoidBill       from '@/views/VoidBill.vue';
import AddNote        from '@/views/AddNote.vue';
import ChooseCust     from '@/views/ChooseCust.vue';
import CashCalc       from '@/views/CashCalc.vue';
import ShiftReport    from '@/views/ShiftReport.vue';
import PayCash        from '@/views/PayCash.vue';
import SwipeCard      from '@/views/SwipeCard.vue';
import StockDelivery  from '@/views/StockDelivery.vue';
import SplitBill      from '@/views/SplitBill.vue';
import MergeBill      from '@/views/MergeBill.vue';
import PayCommission  from '@/views/PayCommission.vue';
import DoPayment      from '@/views/DoPayment.vue';
import Pay            from '@/views/Pay.vue';
import SetCommission  from '@/views/SetCommission.vue';
import EndOfDay       from '@/views/EndOfDay.vue';
import VariablePrice  from '@/views/VariablePrice.vue';
import ChangeTime     from '@/views/ChangeTime.vue';
import EndOfMonth     from '@/views/EndOfMonth.vue';
import PrintArticleWorkday     from '@/views/PrintArticleWorkday.vue';

import store          from '@/store';
import { RESET_AUTH } from '@/store/mutation-types';
/* eslint-enable */

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: {
        name: 'order',
      },
      meta: {
        guest: true,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        guest: true,
        requiresAuth: false,
        title: 'Login',
      },
    },
    {
      path: '/order',
      name: 'order',
      component: Order,
      meta: {
        title: 'Order',
      },
    },
    {
      path: '/new-order',
      name: 'new-order',
      component: NewOrder,
      meta: {
        title: 'New Order',
        fullPage: true,
      },
    },
    {
      path: '/add-customer',
      name: 'add-customer',
      component: AddCustomer,
      meta: {
        title: 'Add Customer'
      },
    },
    {
      path: '/add-staff',
      name: 'add-staff',
      component: AddStaff,
      meta: {
        title: 'Add Staff',
        fullPage: true,
      },
    },
    {
      path: '/bills-open',
      name: 'bills-open',
      component: BillsOpen,
      meta: {
        title: 'Bills Open',
        fullPage: true,
      },
    },
    {
      path: '/change-order',
      name: 'change-order',
      component: ChangeOrder,
      meta: {
        title: 'Change Table/Room/Cover',
      },
    },
    {
      path: '/bills-detail',
      name: 'bills-detail',
      component: BillsDetail,
      meta: {
        title: 'Bills Detail',
        fullPage: true,
      },
    },
    {
      path: '/bills-reprint',
      name: 'bills-reprint',
      component: BillsReprint,
      meta: {
        title: 'Bills Reprint',
        fullPage: true,
      },
    },
    {
      path: '/void-bill',
      name: 'void-bill',
      component: VoidBill,
      meta: {
        title: 'Void Bill',
      },
    },
    {
      path: '/staffs',
      name: 'staffs',
      component: Staffs,
      meta: {
        title: 'All Staffs',
        fullPage: true,
      },
      alias: ['/staffs-out', '/staffs-in'],
    },
    {
      path: '/add-note',
      name: 'add-note',
      component: AddNote,
      meta: {
        requiresAuth: true,
        title: 'Add Note',
      },
    },
    {
      path: '/choose-cust',
      name: 'choose-cust',
      component: ChooseCust,
      meta: {
        title: 'Choose Cust',
      },
    },
    {
      path: '/order-level',
      name: 'order-level',
      component: OrderLevel,
      meta: {
        title: 'Order Level',
      },
    },
    {
      path: '/cash-calc',
      name: 'cash-calc',
      component: CashCalc,
      meta: {
        title: 'Cash Calc',
        fullPage: true,
      },
    },
    {
      path: '/shift-report',
      name: 'shift-report',
      component: ShiftReport,
      meta: {
        title: 'Shift Report',
        fullPage: true,
      },
    },
    {
      path: '/pay-cash',
      name: 'pay-cash',
      component: PayCash,
      meta: {
        title: 'Pay Card',
        fullPage: true,
      },
    },
    {
      path: '/swipe-card',
      name: 'swipe-card',
      component: SwipeCard,
      meta: {
        title: 'Swipe Card',
        fullPage: true,
      },
    },
    {
      path: '/stock-delivery',
      name: 'stock-delivery',
      component: StockDelivery,
      meta: {
        title: 'Stock Delivery',
        fullPage: true,
      },
    },
    {
      path: '/split-bill',
      name: 'split-bill',
      component: SplitBill,
      meta: {
        title: 'Split Bill',
        fullPage: true,
      },
      props: route => ({
        originBill: route.params.bill,
      }),
    },
    {
      path: '/merge-bill',
      name: 'merge-bill',
      component: MergeBill,
      meta: {
        title: 'Merge Bill',
      },
      props: route => ({
        firstBill: route.params.bill,
      }),
    },
    {
      path: '/pay-commission',
      name: 'pay-commission',
      component: PayCommission,
      meta: {
        title: 'Pay Commission',
        fullPage: true,
      },
    },
    {
      path: '/do-payment',
      name: 'do-payment',
      component: DoPayment,
      meta: {
        title: 'Do Payment',
        fullPage: true,
      },
    },
    {
      path: '/pay',
      name: 'pay',
      component: Pay,
      meta: {
        title: 'pay',
      },
    },
    {
      path: '/set-commission',
      name: 'set-commission',
      component: SetCommission,
      meta: {
        title: 'Set Commission',
      },
      props: route => ({
        product: route.params.product,
        force: route.params.force ? route.params.force : false,
      }),
    },
    {
      path: '/variable-price',
      name: 'variable-price',
      component: VariablePrice,
      meta: {
        title: 'Variable Price',
      },
      props: route => ({
        article: route.params.article,
      }),
    },
    {
      path: '/end-of-day',
      name: 'end-of-day',
      component: EndOfDay,
      meta: {
        title: 'End Of Day',
        fullPage: true,
      },
    },
    {
      path: '/end-of-month',
      name: 'end-of-month',
      component: EndOfMonth,
      meta: {
        title: 'End Of Month',
        fullPage: true,
      },
    },
    {
      path: '/change-time',
      name: 'change-time',
      component: ChangeTime,
      meta: {
        title: 'Change Time',
      },
    },
    {
      path: 'print-article-workday',
      name: 'print-article-workday',
      component: PrintArticleWorkday,
      meta: {
        title: 'Print Articles wokday',
        fullPage: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  document.title = `${process.env.VUE_APP_TITLE} - ${to.meta.title}`;
  if (to.matched.some(
    record => typeof (record.meta.requiresAuth) === 'undefined'
                  || record.meta.requiresAuth !== false,
  )
  ) {
    store.commit(RESET_AUTH);
    if (store.state.auth.token === '') {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
